import styled from 'styled-components';

const Wrapper = styled.section`
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: linear-gradient(160deg, #0f172a 0%, #1e1b4b 60%, #0f172a 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(
      ellipse 80% 60% at 50% 0%,
      rgba(99, 102, 241, 0.18) 0%,
      transparent 70%
    );
    pointer-events: none;
  }

  .logo {
    display: block;
    margin: 0 auto 1.5rem;
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    border-radius: 14px;
    object-fit: contain;
    padding: 10px;
  }

  .form {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 420px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 20px;
    padding: 2.5rem 2rem;
    backdrop-filter: blur(20px);
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.4);
    margin: 1rem;
  }

  h3 {
    text-align: center;
    color: #f8fafc;
    font-size: 1.4rem;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin-bottom: 1.5rem;
  }

  .form-label {
    color: #94a3b8;
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 0.35rem;
    display: block;
  }

  .form-input {
    width: 100%;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    padding: 0.65rem 0.875rem;
    color: #f1f5f9;
    font-size: 0.9rem;
    transition: border-color 0.15s, background 0.15s;
    &::placeholder { color: #475569; }
    &:focus {
      outline: none;
      border-color: #6366f1;
      background: rgba(99, 102, 241, 0.08);
    }
  }

  .form-row {
    margin-bottom: 1rem;
  }

  .btn {
    width: 100%;
    padding: 0.75rem;
    border: none;
    border-radius: 10px;
    font-size: 0.9rem;
    font-weight: 700;
    cursor: pointer;
    transition: transform 0.15s, opacity 0.15s;
    margin-top: 0.75rem;
    &:disabled { opacity: 0.6; cursor: not-allowed; }
  }

  .btn-block {
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: #fff;
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.35);
    &:hover:not(:disabled) { transform: translateY(-1px); opacity: 0.92; }
  }

  .btn-hipster {
    background: rgba(255, 255, 255, 0.06);
    color: #a5b4fc;
    border: 1px solid rgba(99, 102, 241, 0.3);
    box-shadow: none;
    &:hover:not(:disabled) { background: rgba(99, 102, 241, 0.12); }
  }

  p {
    text-align: center;
    margin-top: 1.25rem;
    font-size: 0.85rem;
    color: #64748b;
  }

  .member-btn {
    background: transparent;
    border: none;
    color: #818cf8;
    font-weight: 600;
    cursor: pointer;
    font-size: 0.85rem;
    margin-left: 0.3rem;
    transition: color 0.15s;
    &:hover { color: #a5b4fc; }
  }
`;

export default Wrapper;
